// /src/store/modules/notification.js
export const namespaced = true

export const state = {
  all: [],
  nextId: 0,
}

export const mutations = {
  PUSH(state, notification) {
    state.all.push({
      ...notification,
      id: state.nextId,
    })
  },
  DELETE(state, notificationToRemove) {
    return (state.all = state.all.filter(
      notification => notification.id !== parseInt(notificationToRemove),
    ))
  },
  INCREMENT_NEXT_ID(state) {
    return state.nextId++
  },
}

export const actions = {
  add({ commit }, notification) {
    try {
      commit('INCREMENT_NEXT_ID')
      commit('PUSH', notification)
    } catch (err) {
      console.log(err)
    }
  },
  remove({ commit }, notificationToRemove) {
    try {
      commit('DELETE', notificationToRemove)
    } catch (err) {
      console.log(err)
    }
  },
}

export const getters = {
  all: state => {
    return state.all
      .sort((a, b) => b.id - a.id)
      .sort((a, b) => (a.autoClose === b.autoClose ? 0 : a.autoClose ? 1 : -1))
  },
}
